// let base_url = "http://mine-fastadmin.test/api";
let base_url = "https://admin.hexminer.com/api";
export {
    base_url,
}
